import * as React from 'react';
import { Col, FormGroup, ControlLabel, Form, Button } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { flow, map, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import {isRequired, isValidDate, isEmail} from '../../../../../../util/validators';
import {IStore} from '../../../../../../redux/IStore';
import { Link } from 'react-router-dom';

interface IResetPasswordFormProps {
  actions: {
    push: (route: string) => void;
  };
  buttonText: string;
}

class ResetPasswordForm extends React.Component<IResetPasswordFormProps> {
  public render() {
    const {handleSubmit, buttonText, auth} = this.props;
    const hasAuthErrors = auth && auth.error && ((auth.error.login && auth.error.login.length) ||
      (auth.error.reset && auth.error.reset.length) || (auth.error.update  && auth.error.update.length));

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="blue-section-group">
          <div className="blue-section">
            <FormGroup controlId="email">
              <Col componentClass={ControlLabel} sm={3}>
                Registered email
              </Col>
              <Col sm={5}>
                <Field
                  name="email"
                  type="email"
                  autoComplete="new-password"
                  component={FieldFormControl}
                  validate={[isRequired, isEmail]}
                />
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <FormGroup controlId="dob">
              <Col componentClass={ControlLabel} sm={3}>
                Date of birth
              </Col>
              <Col sm={5}>
                <Field
                  name="dob"
                  type="masked-date"
                  autoComplete="new-password"
                  component={FieldFormControl}
                  validate={[isRequired, isValidDate]}
                />
              </Col>
            </FormGroup>
          </div>
          <div className="blue-section">
            <div className="margin-bottom">
              Your password must be a minimum of 10 characters long with at least one lower case, one uppercase letter,
              one number and one of the following special characters : !@#$%?
            </div>
            <FormGroup controlId="password">
              <Col componentClass={ControlLabel} sm={3}>
                New Password
              </Col>
              <Col sm={5}>
                <Field
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="name">
              <Col componentClass={ControlLabel} sm={3}>
                Confirm new password
              </Col>
              <Col sm={5}>
                <Field
                  name="passwordConfirmation"
                  type="password"
                  autoComplete="new-password"
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
          </div>
        </div>
        {!!hasAuthErrors && (
          <div className="alert alert-danger" style={{marginTop: '10px'}}>
            {map(auth.error.reset, (error, key) => {
              return <p key={key}>{error.detail}</p>;
            })}
          </div>
        )}
        <div className="btn-bar">
          <Button
            bsStyle="primary"
            type="submit"
            bsSize="lg"
            className="pull-right"
          >
            {buttonText ? buttonText : 'RESET PASSWORD'}
          </Button>
          <div className="clearfix "/>
          {buttonText === 'SET PASSWORD' && (
            <div style={{ marginTop: '10px' }}>
              <Link to="/auth/create-an-account" className="pull-right underline">
                Request password reset
              </Link>
            </div>
          )
          }
        </div>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'Your confirmed password doesn\'t match the first field, please enter them again.';
  }
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'reset_password',
    destroyOnUnmount: false,
    validate,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('reset_password');

    return component;
  },
  connect(
    (state: IStore) => ({
      auth: state.auth,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(ResetPasswordForm);
